import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SlideOver } from '@/components/design-system/molecules/slide-over';
import { DiscussionThreadInput } from '../discussion-thread-input';
import { useDiscussionThreadProviderContext } from '../../hooks/use-discussion-thread';
import { DiscussionThreadMessageList } from '../discussion-thread-message-list';
import { useAuthContext } from '@/hooks/use-auth';
import { useDeleteDiscussionThreadMessage } from '../../hooks/use-delete-thread-message';
import { amountToString } from '@/utils/util_helpers/formatting/amount_to_string';
import { Dialog } from '@headlessui/react';
import { HeroIcons } from '@/components/design-system/atoms/icon';

const DiscussionThreadContent = () => {
  const {
    showDiscussionThread,
    closeDiscussionThread,
    discussionThreadHasBeenCreated,
    fetch: { data, isLoading }
  } = useDiscussionThreadProviderContext()!;

  const { mutate: deleteDiscussionThreadMessage } = useDeleteDiscussionThreadMessage();
  const { user } = useAuthContext()!;
  const { t } = useTranslation();
  const { setFilterDiscussablesByDiscussableId } = useDiscussionThreadProviderContext()!;

  useEffect(() => {
    if (data?.data.discussable_id && data.data.discussable_type === 'Rent') {
      setFilterDiscussablesByDiscussableId(data.data.discussable_id);
    }
  }, [data])

  return (
    <SlideOver
      show={showDiscussionThread.show}
      className="!z-[60]"
      title="Notes"
      onClose={() => closeDiscussionThread()}
    >
      {data?.data && data.data.discussable_type === 'Rent' && (
        <SlideOver.SlideOverTopContent>
          <div className="flex items-start gap-2 bg-N100 p-3">
            <a href="#" onClick={() => closeDiscussionThread()}>
              <HeroIcons type="outline/medium" name="x-circle" size={24} />
            </a>

            <div className="flex flex-col">
              <Dialog.Title>
                <div className="text-lead1 text-text-primaryHeavy font-bold font-Vollkorn">
                  {data.data.discussable.tenant.name}
                </div>
                <div className="text-small text-text-primaryHeavy font-bold">
                  Rent: {amountToString(data.data.discussable.full_amount)}
                </div>
                <div className="text-small text-text-primaryMedium">
                  {data.data.discussable.contract.colocation.name} - #{data.data.discussable.contract.room_number}
                </div>
              </Dialog.Title>
            </div>
          </div>
        </SlideOver.SlideOverTopContent>
      )}

      <SlideOver.SlideOverContent
        className="items-center gap-3"
        scrollToEnd={true}
      >
        <DiscussionThreadMessageList
          messages={data?.data.messages ?? []}
          isLoading={isLoading}
          currentUserId={user?.id ?? 1}
          onDelete={(messageId: number) =>
            deleteDiscussionThreadMessage.mutate({ id: messageId })
          }
        />
      </SlideOver.SlideOverContent>

      <SlideOver.SlideOverEmptyState
        show={
          data?.data.messages.length === 0 || !discussionThreadHasBeenCreated
        }
        illustration="EmptyBox"
        title={t(
          'js.features.shared.discussion_thread.empty_state.empty_state_title'
        )}
      />
      <SlideOver.SlideOverBottomContent className="w-full px-5">
        <DiscussionThreadInput />
      </SlideOver.SlideOverBottomContent>
    </SlideOver>
  );
};

export { DiscussionThreadContent };
